var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerTop"},[_c('div',{staticClass:"left"},[_vm._v("<返回")]),_vm._v(" "),_c('div',{staticClass:"right",on:{"click":_vm.changeType}},[_vm._v(_vm._s(_vm.showType?'文本':'PDF'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc51fea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerTop.vue
// module id = null
// module chunks = 